import React from 'react'
import injectSheet from 'react-jss'
import {
  ContentContainer,
  InfoContainer,
  TextButton,
} from '../../'

const OfferRequested = (props) => {
  const {
    classes,
    form,
    history,
  } = props

  const handleClick = () => {
    history.push('/angebot')
  }

  return (
    <ContentContainer small>
      <InfoContainer>
        <h2>{form.confirmationTitle}</h2>
        <h4>{form.confirmationSubTitle}</h4>
        <p>{form.confirmationDescription}</p>
        <div className={`${classes.buttonContainer}`}>
          <TextButton
            index={0}
            handleClick={() => handleClick()}
            text={form.confirmationButton}
          />
        </div>
      </InfoContainer>
    </ContentContainer>
  )
}

const styles = () => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
})


export default injectSheet(styles)(OfferRequested)



// WEBPACK FOOTER //
// ./src/modules/offer/components/offerRequested.jsx